import { set } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { createFetchManyHandler } from '../../../../helpers/reducerRoutineCrudHandler';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import { fetchReservationToday, unlinkReservation } from '../../sagas/routines';
import {
  clearReservationToday,
  reservationTodayOnChangePage,
  reservationTodayOnChangeOrder
} from '../../actions/today';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  fetchingError: null,
  pagination: paginationState(),
  order: 'requestTime:asc'
};

const unlinkReservationHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set(`all.${response.id}`, response, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

const clearReservationTodayHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const reservationTodayOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const reservationTodayOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchReservationToday),
  ...unlinkReservationHandler(unlinkReservation),
  ...clearReservationTodayHandler(clearReservationToday),
  ...reservationTodayOnChangePageHandler(reservationTodayOnChangePage),
  ...reservationTodayOnChangeOrderHandler(reservationTodayOnChangeOrder)
});
